import { maxWidth, minWidth } from '@/assets/styles/mixins.css.js';
import styled, { css } from 'styled-components';
import vars from '@/assets/styles/vars';

const Review = styled.blockquote`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--review-space-top, 44px) var(--review-space-left, 44px);
  font-weight: 300;
  background: var(--review-bg-color, #fff);
  box-shadow: var(--review-shadow, 0 0 0 1px var(--color-border));

  ${maxWidth(vars.breakpoints.mTablet)`
    --review-space-top: 19px;
    --review-space-left: 19px;
  `}

  ${(props) =>
    props.reviewType === 'slide' &&
    css`
      --review-shadow: none;
      --review-font-size: 20px;
      --review-line-height: 1.4;

      justify-content: flex-end;
      height: 100%;
      background: var(--review-bg-color, var(--color-bg-accent));
      user-select: none;

      ${Review.Text} {
        display: -webkit-box;
        max-height: calc(var(--review-font-size) * var(--review-line-height) * var(--review-max-lines, 10));
        -webkit-line-clamp: var(--review-max-lines, 10);
        -moz-line-clamp: var(--review-max-lines, 10);
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: opacity 1s, transform 1s;
      }

      ${maxWidth(1500)`
        --review-max-lines: 8;
      `}

      ${maxWidth(vars.breakpoints.xsDesktop)`
        --review-font-size: 19px;
      `}

      ${maxWidth(1160)`
        --review-max-lines: 6;
      `}

      ${maxWidth(vars.breakpoints.tablet)`
        --review-font-size: 14px;
        --review-line-height: 1.6;
        --review-bg-color: #fff;
        --review-shadow: 0 0 0 1px var(--color-border);
        justify-content: flex-start;

        ${Review.Text} {
          display: block;
          max-height: none;
          margin-bottom: auto;
        }
        
        ${Review.Text}, ${Review.Author}, ${Review.City}, ${Review.Img} {
          opacity: 1 !important;
          transform: none !important;
          transition: none !important;
        }
      `}
    `}

    ${(props) =>
    props.reviewType === 'content' &&
    css`
      ${maxWidth(vars.breakpoints.tablet - 1)`
          height: 100%;

          ${Review.Footer} {
            margin-top: auto;
          }
        `}
    `}
  ${(props) =>
    props.p && props.p === 'mid' &&
    css`
      ${minWidth(vars.breakpoints.tablet + 1)`
          padding: 35px;
        `}
    `}
    
`;

Review.Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap:wrap-reverse;
  gap: 10px;

  ${maxWidth(vars.breakpoints.tablet)`
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: nowrap;
  `}
`;
Review.Author = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;

  ${maxWidth(vars.breakpoints.tablet)`
      gap: 15px;
    `}
`;

Review.Img = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
  width: 86px;
  height: 86px;
  border-radius: 50%;
  color: #f9f9fb;
  background: #dfe3ec;
  transition: opacity 1s, transform 1s;
`;

Review.Name = styled.p`
  font-weight: 400;
  font-size: 22px;
  line-height: 1.2;
  color: var(--color-decor);
  transition: opacity 1s, transform 1s;

  &:not(:only-child) {
    margin-bottom: 8px;
  }
`;

Review.Service = styled.p`
  font-size: 16px;
  line-height: 1.25;
  color: var(--color-main);
  transition: opacity 1s, transform 1s;

  b {
    font-weight: 600;
  }
`;

Review.Rating = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  padding: 5px 0;
  margin-left:auto;

  ${maxWidth(vars.breakpoints.tablet)`
      flex-direction: row;
      align-items: center;
      justify-content:space-between;
      margin-left:0;
      width:100%;
  `}
`;

Review.Stars = styled.div`
  display: flex;
  align-items: center;
  gap:5px;
`;

Review.Date = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 125%;
  text-align: right;
  color: #acacac;
`;

Review.Text = styled.p`
  font-weight:400;
  font-size: var(--review-font-size, 16px);
  line-height: var(--review-line-height, 1.6);
  color: #000;
  padding-top: 20px;
  ${maxWidth(vars.breakpoints.tablet)`
    padding-top: 10px;
  `}
`;

export default Review;
